import { render, staticRenderFns } from "./waitingOrder.vue?vue&type=template&id=79d8bdf2&"
import script from "./waitingOrder.vue?vue&type=script&lang=js&"
export * from "./waitingOrder.vue?vue&type=script&lang=js&"
import style0 from "./waitingOrder.vue?vue&type=style&index=0&id=79d8bdf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports